import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    @observable eventObj;
    @observable errorObj;
    @observable killPolling;
    @observable pollingStarted;

    constructor() {
        this.errorCounter = 0;
        this.killPolling = false;
        this.pollingStarted = false;
        this.eventObj = {
            event: undefined,
            payload: {}
        };
        this.errorStack = [];
        this.errorObj = {
            clientID: utils.getReceivePrefix() + utils.getID(),
            errorStack: this.errorStack.toString()
        };
    }

    longPollEvents() {
        this.pollingStarted = true;
        if(!this.killPolling && utils.getID()) {
            try {
                axios.post(utils.getMsgUrl('receiveService'), {
                    clientId: utils.getReceivePrefix() + utils.getID()
                })
                .then((resp) => {
                    if(resp.data.event === 'sessionEnd' || resp.data.status === 'error') {
                        this.updateError("Service responded with status error or sessionEnd.");
                        this.stopPollingEvents();
                        return;
                    }
                    this.eventObj = resp.data;
                    this.errorCounter = 0;
                    utils.defer(this.longPollEvents.bind(this));
                })
                .catch((error) => {
                    this.errorCounter++;
                    this.updateError(error.message);
                    if(this.errorCounter >= 10) {
                        this.stopPollingEvents();
                        return;
                    }
                    utils.defer(this.longPollEvents.bind(this), 1000);
                })
            } catch (e) {
                this.updateError(e.message);
            }
        }
    }

    updateError(e) {
        this.errorStack.push(e);
        this.errorObj = {
            clientID: utils.getReceivePrefix() + utils.getID(),
            errorStack: this.errorStack
        }
    }

    resetPolling = () => {
        if(this.killPolling === true) {
            this.killPolling = false;
            this.errorCounter = 0;
            this.pollingStarted = false;
            this.eventObj = {
                event: undefined,
                payload: {}
            };
            this.errorStack = [];
            this.longPollEvents();
        }
    }

    stopPollingEvents() {
        this.killPolling = true;
    }
}
var EventStore = new store;
export default EventStore;


// WEBPACK FOOTER //
// ./src/js/stores/EventStore.js